/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccountConfigurationErrorRouteImport } from './routes/account-configuration-error'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as appAdminLayoutRouteImport } from './routes/(app)/_admin-layout'
import { Route as appMainLayoutRouteImport } from './routes/(app)/_main-layout'
import { Route as AuthAuthLayoutRouteImport } from './routes/auth/_auth-layout'
import { Route as appAdminLayoutAdminRouteImport } from './routes/(app)/_admin-layout/admin'
import { Route as appMainLayoutComplianceRouteImport } from './routes/(app)/_main-layout/_compliance'
import { Route as appMainLayoutSystemStatusRouteImport } from './routes/(app)/_main-layout/system-status'
import { Route as AuthAuthLayoutForgotPasswordRouteImport } from './routes/auth/_auth-layout/forgot-password'
import { Route as AuthAuthLayoutSigninRouteImport } from './routes/auth/_auth-layout/signin'
import { Route as AuthAuthLayoutSignupRouteImport } from './routes/auth/_auth-layout/signup_'
import { Route as appAdminLayoutAdminComplianceRouteImport } from './routes/(app)/_admin-layout/admin_.compliance'
import { Route as appAdminLayoutAdminFxRouteImport } from './routes/(app)/_admin-layout/admin_.fx'
import { Route as appAdminLayoutAdminPaymentsRouteImport } from './routes/(app)/_admin-layout/admin_.payments'
import { Route as appMainLayoutBalancesBalancesRouteImport } from './routes/(app)/_main-layout/_balances/balances'
import { Route as appMainLayoutComplianceComplianceRouteImport } from './routes/(app)/_main-layout/_compliance/compliance'
import { Route as appMainLayoutDashboardIndexRouteImport } from './routes/(app)/_main-layout/_dashboard/index'
import { Route as appMainLayoutExchangeExchangeRouteImport } from './routes/(app)/_main-layout/_exchange/exchange'
import { Route as appMainLayoutLabsLabsRouteImport } from './routes/(app)/_main-layout/_labs/labs'
import { Route as appMainLayoutPayByLinkPayByLinkRouteImport } from './routes/(app)/_main-layout/_pay-by-link/pay-by-link'
import { Route as appMainLayoutPaymentsPaymentsRouteImport } from './routes/(app)/_main-layout/_payments/payments'
import { Route as appMainLayoutReportingReportingRouteImport } from './routes/(app)/_main-layout/_reporting/reporting'
import { Route as appMainLayoutSettingsSettingsRouteImport } from './routes/(app)/_main-layout/_settings/settings'
import { Route as appMainLayoutTransactionMonitoringTransactionMonitoringRouteImport } from './routes/(app)/_main-layout/_transaction-monitoring/transaction-monitoring'
import { Route as AuthAuthLayoutFxAiApproveRouteImport } from './routes/auth/_auth-layout/fx-ai/approve'
import { Route as AuthAuthLayoutResetPasswordTokenRouteImport } from './routes/auth/_auth-layout/reset-password/$token'
import { Route as AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRouteImport } from './routes/auth/_auth-layout/set-two-factor/$twoFactorRequestId'
import { Route as AuthAuthLayoutSignupSuccessRouteImport } from './routes/auth/_auth-layout/signup.success'
import { Route as AuthAuthLayoutVerifyOtpOtpRequestIdRouteImport } from './routes/auth/_auth-layout/verify-otp/$otpRequestId'
import { Route as appAdminLayoutAdminComplianceCasesRouteImport } from './routes/(app)/_admin-layout/admin_.compliance.cases'
import { Route as appAdminLayoutAdminComplianceDocumentTypesRouteImport } from './routes/(app)/_admin-layout/admin_.compliance.document-types'
import { Route as appAdminLayoutAdminComplianceOverviewRouteImport } from './routes/(app)/_admin-layout/admin_.compliance.overview'
import { Route as appAdminLayoutAdminMerchantsMerchantIdRouteImport } from './routes/(app)/_admin-layout/admin_.merchants_.$merchantId'
import { Route as appAdminLayoutAdminPaymentsPaymentIdRouteImport } from './routes/(app)/_admin-layout/admin_.payments_.$paymentId'
import { Route as appMainLayoutBalancesBalancesOverviewRouteImport } from './routes/(app)/_main-layout/_balances/balances.overview'
import { Route as appMainLayoutComplianceComplianceIndexRouteImport } from './routes/(app)/_main-layout/_compliance/compliance.index'
import { Route as appMainLayoutComplianceComplianceActionRequiredRouteImport } from './routes/(app)/_main-layout/_compliance/compliance.action-required'
import { Route as appMainLayoutComplianceComplianceApprovedRouteImport } from './routes/(app)/_main-layout/_compliance/compliance.approved'
import { Route as appMainLayoutComplianceComplianceClosedRouteImport } from './routes/(app)/_main-layout/_compliance/compliance.closed'
import { Route as appMainLayoutComplianceComplianceOpenRouteImport } from './routes/(app)/_main-layout/_compliance/compliance.open'
import { Route as appMainLayoutComplianceComplianceRejectedRouteImport } from './routes/(app)/_main-layout/_compliance/compliance.rejected'
import { Route as appMainLayoutComplianceComplianceRejectedRequirementsRouteImport } from './routes/(app)/_main-layout/_compliance/compliance.rejected-requirements'
import { Route as appMainLayoutComplianceComplianceWithVolumeRouteImport } from './routes/(app)/_main-layout/_compliance/compliance.with-volume'
import { Route as appMainLayoutComplianceComplianceCaseIdRouteImport } from './routes/(app)/_main-layout/_compliance/compliance_.$caseId'
import { Route as appMainLayoutExchangeExchangeIndexRouteImport } from './routes/(app)/_main-layout/_exchange/exchange/index'
import { Route as appMainLayoutExchangeExchangeMcpSetupRouteImport } from './routes/(app)/_main-layout/_exchange/exchange/mcp-setup'
import { Route as appMainLayoutExchangeExchangeNotificationsRouteImport } from './routes/(app)/_main-layout/_exchange/exchange/notifications'
import { Route as appMainLayoutExchangeExchangePayoutsRouteImport } from './routes/(app)/_main-layout/_exchange/exchange/payouts'
import { Route as appMainLayoutExchangeExchangeTradesRouteImport } from './routes/(app)/_main-layout/_exchange/exchange/trades'
import { Route as appMainLayoutInStoreInStoreAgentsRouteImport } from './routes/(app)/_main-layout/_in-store/in-store.agents'
import { Route as appMainLayoutPayByLinkPayByLinkPaymentIntentIdRouteImport } from './routes/(app)/_main-layout/_pay-by-link/pay-by-link_.$paymentIntentId'
import { Route as appMainLayoutPaymentsPaymentsPayinRouteImport } from './routes/(app)/_main-layout/_payments/payments.payin'
import { Route as appMainLayoutPaymentsPaymentsPayoutRouteImport } from './routes/(app)/_main-layout/_payments/payments.payout'
import { Route as appMainLayoutPaymentsPaymentsPaymentIdRouteImport } from './routes/(app)/_main-layout/_payments/payments_.$paymentId'
import { Route as appMainLayoutSettingsSettingsAccountSettingsRouteImport } from './routes/(app)/_main-layout/_settings/settings.account-settings'
import { Route as appMainLayoutSettingsSettingsAccountsRouteImport } from './routes/(app)/_main-layout/_settings/settings.accounts'
import { Route as appMainLayoutSettingsSettingsInstitutionsRouteImport } from './routes/(app)/_main-layout/_settings/settings.institutions'
import { Route as appMainLayoutSettingsSettingsNotificationsRouteImport } from './routes/(app)/_main-layout/_settings/settings.notifications'
import { Route as appMainLayoutSettingsSettingsSecurityRouteImport } from './routes/(app)/_main-layout/_settings/settings.security'
import { Route as appMainLayoutSettingsSettingsUsersRouteImport } from './routes/(app)/_main-layout/_settings/settings.users'
import { Route as appMainLayoutSettingsSettingsWebhooksCallbacksRouteImport } from './routes/(app)/_main-layout/_settings/settings.webhooks-callbacks'
import { Route as appMainLayoutTransactionMonitoringTransactionMonitoringSplatRouteImport } from './routes/(app)/_main-layout/_transaction-monitoring/transaction-monitoring.$'
import { Route as appAdminLayoutAdminComplianceCasesCaseIdRouteImport } from './routes/(app)/_admin-layout/admin_.compliance_.cases_.$caseId'
import { Route as appAdminLayoutAdminFxTradesTradeIdRouteImport } from './routes/(app)/_admin-layout/admin_.fx_.trades_.$tradeId'
import { Route as appAdminLayoutAdminMerchantsMerchantIdTabRouteImport } from './routes/(app)/_admin-layout/admin_.merchants_.$merchantId.$tab'
import { Route as appMainLayoutInStoreInStoreAgentsAgentIdRouteImport } from './routes/(app)/_main-layout/_in-store/in-store.agents_.$agentId'
import { Route as appMainLayoutInStoreInStoreAgentsAgentIdConfigRouteImport } from './routes/(app)/_main-layout/_in-store/in-store.agents_.$agentId.config'

const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountConfigurationErrorRoute =
  AccountConfigurationErrorRouteImport.update({
    id: '/account-configuration-error',
    path: '/account-configuration-error',
    getParentRoute: () => rootRouteImport,
  } as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminLayoutRoute = appAdminLayoutRouteImport.update({
  id: '/(app)/_admin-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const appMainLayoutRoute = appMainLayoutRouteImport.update({
  id: '/(app)/_main-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAuthLayoutRoute = AuthAuthLayoutRouteImport.update({
  id: '/auth/_auth-layout',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminLayoutAdminRoute = appAdminLayoutAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => appAdminLayoutRoute,
} as any)
const appMainLayoutComplianceRoute = appMainLayoutComplianceRouteImport.update({
  id: '/_compliance',
  getParentRoute: () => appMainLayoutRoute,
} as any)
const appMainLayoutSystemStatusRoute =
  appMainLayoutSystemStatusRouteImport.update({
    id: '/system-status',
    path: '/system-status',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const AuthAuthLayoutForgotPasswordRoute =
  AuthAuthLayoutForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutSigninRoute = AuthAuthLayoutSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthAuthLayoutRoute,
} as any)
const AuthAuthLayoutSignupRoute = AuthAuthLayoutSignupRouteImport.update({
  id: '/signup_',
  path: '/signup',
  getParentRoute: () => AuthAuthLayoutRoute,
} as any)
const appAdminLayoutAdminComplianceRoute =
  appAdminLayoutAdminComplianceRouteImport.update({
    id: '/admin_/compliance',
    path: '/admin/compliance',
    getParentRoute: () => appAdminLayoutRoute,
  } as any)
const appAdminLayoutAdminFxRoute = appAdminLayoutAdminFxRouteImport.update({
  id: '/admin_/fx',
  path: '/admin/fx',
  getParentRoute: () => appAdminLayoutRoute,
} as any)
const appAdminLayoutAdminPaymentsRoute =
  appAdminLayoutAdminPaymentsRouteImport.update({
    id: '/admin_/payments',
    path: '/admin/payments',
    getParentRoute: () => appAdminLayoutRoute,
  } as any)
const appMainLayoutBalancesBalancesRoute =
  appMainLayoutBalancesBalancesRouteImport.update({
    id: '/_balances/balances',
    path: '/balances',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutComplianceComplianceRoute =
  appMainLayoutComplianceComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => appMainLayoutComplianceRoute,
  } as any)
const appMainLayoutDashboardIndexRoute =
  appMainLayoutDashboardIndexRouteImport.update({
    id: '/_dashboard/',
    path: '/',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutExchangeExchangeRoute =
  appMainLayoutExchangeExchangeRouteImport.update({
    id: '/_exchange/exchange',
    path: '/exchange',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutLabsLabsRoute = appMainLayoutLabsLabsRouteImport.update({
  id: '/_labs/labs',
  path: '/labs',
  getParentRoute: () => appMainLayoutRoute,
} as any)
const appMainLayoutPayByLinkPayByLinkRoute =
  appMainLayoutPayByLinkPayByLinkRouteImport.update({
    id: '/_pay-by-link/pay-by-link',
    path: '/pay-by-link',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutPaymentsPaymentsRoute =
  appMainLayoutPaymentsPaymentsRouteImport.update({
    id: '/_payments/payments',
    path: '/payments',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutReportingReportingRoute =
  appMainLayoutReportingReportingRouteImport.update({
    id: '/_reporting/reporting',
    path: '/reporting',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutSettingsSettingsRoute =
  appMainLayoutSettingsSettingsRouteImport.update({
    id: '/_settings/settings',
    path: '/settings',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutTransactionMonitoringTransactionMonitoringRoute =
  appMainLayoutTransactionMonitoringTransactionMonitoringRouteImport.update({
    id: '/_transaction-monitoring/transaction-monitoring',
    path: '/transaction-monitoring',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const AuthAuthLayoutFxAiApproveRoute =
  AuthAuthLayoutFxAiApproveRouteImport.update({
    id: '/fx-ai/approve',
    path: '/fx-ai/approve',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutResetPasswordTokenRoute =
  AuthAuthLayoutResetPasswordTokenRouteImport.update({
    id: '/reset-password/$token',
    path: '/reset-password/$token',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute =
  AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRouteImport.update({
    id: '/set-two-factor/$twoFactorRequestId',
    path: '/set-two-factor/$twoFactorRequestId',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutSignupSuccessRoute =
  AuthAuthLayoutSignupSuccessRouteImport.update({
    id: '/signup/success',
    path: '/signup/success',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutVerifyOtpOtpRequestIdRoute =
  AuthAuthLayoutVerifyOtpOtpRequestIdRouteImport.update({
    id: '/verify-otp/$otpRequestId',
    path: '/verify-otp/$otpRequestId',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const appAdminLayoutAdminComplianceCasesRoute =
  appAdminLayoutAdminComplianceCasesRouteImport.update({
    id: '/cases',
    path: '/cases',
    getParentRoute: () => appAdminLayoutAdminComplianceRoute,
  } as any)
const appAdminLayoutAdminComplianceDocumentTypesRoute =
  appAdminLayoutAdminComplianceDocumentTypesRouteImport.update({
    id: '/document-types',
    path: '/document-types',
    getParentRoute: () => appAdminLayoutAdminComplianceRoute,
  } as any)
const appAdminLayoutAdminComplianceOverviewRoute =
  appAdminLayoutAdminComplianceOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => appAdminLayoutAdminComplianceRoute,
  } as any)
const appAdminLayoutAdminMerchantsMerchantIdRoute =
  appAdminLayoutAdminMerchantsMerchantIdRouteImport.update({
    id: '/admin_/merchants_/$merchantId',
    path: '/admin/merchants/$merchantId',
    getParentRoute: () => appAdminLayoutRoute,
  } as any)
const appAdminLayoutAdminPaymentsPaymentIdRoute =
  appAdminLayoutAdminPaymentsPaymentIdRouteImport.update({
    id: '/admin_/payments_/$paymentId',
    path: '/admin/payments/$paymentId',
    getParentRoute: () => appAdminLayoutRoute,
  } as any)
const appMainLayoutBalancesBalancesOverviewRoute =
  appMainLayoutBalancesBalancesOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => appMainLayoutBalancesBalancesRoute,
  } as any)
const appMainLayoutComplianceComplianceIndexRoute =
  appMainLayoutComplianceComplianceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appMainLayoutComplianceComplianceRoute,
  } as any)
const appMainLayoutComplianceComplianceActionRequiredRoute =
  appMainLayoutComplianceComplianceActionRequiredRouteImport.update({
    id: '/action-required',
    path: '/action-required',
    getParentRoute: () => appMainLayoutComplianceComplianceRoute,
  } as any)
const appMainLayoutComplianceComplianceApprovedRoute =
  appMainLayoutComplianceComplianceApprovedRouteImport.update({
    id: '/approved',
    path: '/approved',
    getParentRoute: () => appMainLayoutComplianceComplianceRoute,
  } as any)
const appMainLayoutComplianceComplianceClosedRoute =
  appMainLayoutComplianceComplianceClosedRouteImport.update({
    id: '/closed',
    path: '/closed',
    getParentRoute: () => appMainLayoutComplianceComplianceRoute,
  } as any)
const appMainLayoutComplianceComplianceOpenRoute =
  appMainLayoutComplianceComplianceOpenRouteImport.update({
    id: '/open',
    path: '/open',
    getParentRoute: () => appMainLayoutComplianceComplianceRoute,
  } as any)
const appMainLayoutComplianceComplianceRejectedRoute =
  appMainLayoutComplianceComplianceRejectedRouteImport.update({
    id: '/rejected',
    path: '/rejected',
    getParentRoute: () => appMainLayoutComplianceComplianceRoute,
  } as any)
const appMainLayoutComplianceComplianceRejectedRequirementsRoute =
  appMainLayoutComplianceComplianceRejectedRequirementsRouteImport.update({
    id: '/rejected-requirements',
    path: '/rejected-requirements',
    getParentRoute: () => appMainLayoutComplianceComplianceRoute,
  } as any)
const appMainLayoutComplianceComplianceWithVolumeRoute =
  appMainLayoutComplianceComplianceWithVolumeRouteImport.update({
    id: '/with-volume',
    path: '/with-volume',
    getParentRoute: () => appMainLayoutComplianceComplianceRoute,
  } as any)
const appMainLayoutComplianceComplianceCaseIdRoute =
  appMainLayoutComplianceComplianceCaseIdRouteImport.update({
    id: '/compliance_/$caseId',
    path: '/compliance/$caseId',
    getParentRoute: () => appMainLayoutComplianceRoute,
  } as any)
const appMainLayoutExchangeExchangeIndexRoute =
  appMainLayoutExchangeExchangeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appMainLayoutExchangeExchangeRoute,
  } as any)
const appMainLayoutExchangeExchangeMcpSetupRoute =
  appMainLayoutExchangeExchangeMcpSetupRouteImport.update({
    id: '/mcp-setup',
    path: '/mcp-setup',
    getParentRoute: () => appMainLayoutExchangeExchangeRoute,
  } as any)
const appMainLayoutExchangeExchangeNotificationsRoute =
  appMainLayoutExchangeExchangeNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => appMainLayoutExchangeExchangeRoute,
  } as any)
const appMainLayoutExchangeExchangePayoutsRoute =
  appMainLayoutExchangeExchangePayoutsRouteImport.update({
    id: '/payouts',
    path: '/payouts',
    getParentRoute: () => appMainLayoutExchangeExchangeRoute,
  } as any)
const appMainLayoutExchangeExchangeTradesRoute =
  appMainLayoutExchangeExchangeTradesRouteImport.update({
    id: '/trades',
    path: '/trades',
    getParentRoute: () => appMainLayoutExchangeExchangeRoute,
  } as any)
const appMainLayoutInStoreInStoreAgentsRoute =
  appMainLayoutInStoreInStoreAgentsRouteImport.update({
    id: '/_in-store/in-store/agents',
    path: '/in-store/agents',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute =
  appMainLayoutPayByLinkPayByLinkPaymentIntentIdRouteImport.update({
    id: '/_pay-by-link/pay-by-link_/$paymentIntentId',
    path: '/pay-by-link/$paymentIntentId',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutPaymentsPaymentsPayinRoute =
  appMainLayoutPaymentsPaymentsPayinRouteImport.update({
    id: '/payin',
    path: '/payin',
    getParentRoute: () => appMainLayoutPaymentsPaymentsRoute,
  } as any)
const appMainLayoutPaymentsPaymentsPayoutRoute =
  appMainLayoutPaymentsPaymentsPayoutRouteImport.update({
    id: '/payout',
    path: '/payout',
    getParentRoute: () => appMainLayoutPaymentsPaymentsRoute,
  } as any)
const appMainLayoutPaymentsPaymentsPaymentIdRoute =
  appMainLayoutPaymentsPaymentsPaymentIdRouteImport.update({
    id: '/_payments/payments_/$paymentId',
    path: '/payments/$paymentId',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutSettingsSettingsAccountSettingsRoute =
  appMainLayoutSettingsSettingsAccountSettingsRouteImport.update({
    id: '/account-settings',
    path: '/account-settings',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsAccountsRoute =
  appMainLayoutSettingsSettingsAccountsRouteImport.update({
    id: '/accounts',
    path: '/accounts',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsInstitutionsRoute =
  appMainLayoutSettingsSettingsInstitutionsRouteImport.update({
    id: '/institutions',
    path: '/institutions',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsNotificationsRoute =
  appMainLayoutSettingsSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsSecurityRoute =
  appMainLayoutSettingsSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsUsersRoute =
  appMainLayoutSettingsSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsWebhooksCallbacksRoute =
  appMainLayoutSettingsSettingsWebhooksCallbacksRouteImport.update({
    id: '/webhooks-callbacks',
    path: '/webhooks-callbacks',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutTransactionMonitoringTransactionMonitoringSplatRoute =
  appMainLayoutTransactionMonitoringTransactionMonitoringSplatRouteImport.update(
    {
      id: '/$',
      path: '/$',
      getParentRoute: () =>
        appMainLayoutTransactionMonitoringTransactionMonitoringRoute,
    } as any,
  )
const appAdminLayoutAdminComplianceCasesCaseIdRoute =
  appAdminLayoutAdminComplianceCasesCaseIdRouteImport.update({
    id: '/admin_/compliance_/cases_/$caseId',
    path: '/admin/compliance/cases/$caseId',
    getParentRoute: () => appAdminLayoutRoute,
  } as any)
const appAdminLayoutAdminFxTradesTradeIdRoute =
  appAdminLayoutAdminFxTradesTradeIdRouteImport.update({
    id: '/admin_/fx_/trades_/$tradeId',
    path: '/admin/fx/trades/$tradeId',
    getParentRoute: () => appAdminLayoutRoute,
  } as any)
const appAdminLayoutAdminMerchantsMerchantIdTabRoute =
  appAdminLayoutAdminMerchantsMerchantIdTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => appAdminLayoutAdminMerchantsMerchantIdRoute,
  } as any)
const appMainLayoutInStoreInStoreAgentsAgentIdRoute =
  appMainLayoutInStoreInStoreAgentsAgentIdRouteImport.update({
    id: '/_in-store/in-store/agents_/$agentId',
    path: '/in-store/agents/$agentId',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutInStoreInStoreAgentsAgentIdConfigRoute =
  appMainLayoutInStoreInStoreAgentsAgentIdConfigRouteImport.update({
    id: '/config',
    path: '/config',
    getParentRoute: () => appMainLayoutInStoreInStoreAgentsAgentIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/about': typeof AboutRoute
  '/account-configuration-error': typeof AccountConfigurationErrorRoute
  '/error': typeof ErrorRoute
  '/auth': typeof AuthAuthLayoutRouteWithChildren
  '/admin': typeof appAdminLayoutAdminRoute
  '/system-status': typeof appMainLayoutSystemStatusRoute
  '/auth/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/auth/signin': typeof AuthAuthLayoutSigninRoute
  '/auth/signup': typeof AuthAuthLayoutSignupRoute
  '/admin/compliance': typeof appAdminLayoutAdminComplianceRouteWithChildren
  '/admin/fx': typeof appAdminLayoutAdminFxRoute
  '/admin/payments': typeof appAdminLayoutAdminPaymentsRoute
  '/balances': typeof appMainLayoutBalancesBalancesRouteWithChildren
  '/compliance': typeof appMainLayoutComplianceComplianceRouteWithChildren
  '/exchange': typeof appMainLayoutExchangeExchangeRouteWithChildren
  '/labs': typeof appMainLayoutLabsLabsRoute
  '/pay-by-link': typeof appMainLayoutPayByLinkPayByLinkRoute
  '/payments': typeof appMainLayoutPaymentsPaymentsRouteWithChildren
  '/reporting': typeof appMainLayoutReportingReportingRoute
  '/settings': typeof appMainLayoutSettingsSettingsRouteWithChildren
  '/transaction-monitoring': typeof appMainLayoutTransactionMonitoringTransactionMonitoringRouteWithChildren
  '/auth/fx-ai/approve': typeof AuthAuthLayoutFxAiApproveRoute
  '/auth/reset-password/$token': typeof AuthAuthLayoutResetPasswordTokenRoute
  '/auth/set-two-factor/$twoFactorRequestId': typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute
  '/auth/signup/success': typeof AuthAuthLayoutSignupSuccessRoute
  '/auth/verify-otp/$otpRequestId': typeof AuthAuthLayoutVerifyOtpOtpRequestIdRoute
  '/': typeof appMainLayoutDashboardIndexRoute
  '/admin/compliance/cases': typeof appAdminLayoutAdminComplianceCasesRoute
  '/admin/compliance/document-types': typeof appAdminLayoutAdminComplianceDocumentTypesRoute
  '/admin/compliance/overview': typeof appAdminLayoutAdminComplianceOverviewRoute
  '/admin/merchants/$merchantId': typeof appAdminLayoutAdminMerchantsMerchantIdRouteWithChildren
  '/admin/payments/$paymentId': typeof appAdminLayoutAdminPaymentsPaymentIdRoute
  '/balances/overview': typeof appMainLayoutBalancesBalancesOverviewRoute
  '/compliance/action-required': typeof appMainLayoutComplianceComplianceActionRequiredRoute
  '/compliance/approved': typeof appMainLayoutComplianceComplianceApprovedRoute
  '/compliance/closed': typeof appMainLayoutComplianceComplianceClosedRoute
  '/compliance/open': typeof appMainLayoutComplianceComplianceOpenRoute
  '/compliance/rejected': typeof appMainLayoutComplianceComplianceRejectedRoute
  '/compliance/rejected-requirements': typeof appMainLayoutComplianceComplianceRejectedRequirementsRoute
  '/compliance/with-volume': typeof appMainLayoutComplianceComplianceWithVolumeRoute
  '/compliance/$caseId': typeof appMainLayoutComplianceComplianceCaseIdRoute
  '/exchange/mcp-setup': typeof appMainLayoutExchangeExchangeMcpSetupRoute
  '/exchange/notifications': typeof appMainLayoutExchangeExchangeNotificationsRoute
  '/exchange/payouts': typeof appMainLayoutExchangeExchangePayoutsRoute
  '/exchange/trades': typeof appMainLayoutExchangeExchangeTradesRoute
  '/in-store/agents': typeof appMainLayoutInStoreInStoreAgentsRoute
  '/pay-by-link/$paymentIntentId': typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute
  '/payments/payin': typeof appMainLayoutPaymentsPaymentsPayinRoute
  '/payments/payout': typeof appMainLayoutPaymentsPaymentsPayoutRoute
  '/payments/$paymentId': typeof appMainLayoutPaymentsPaymentsPaymentIdRoute
  '/settings/account-settings': typeof appMainLayoutSettingsSettingsAccountSettingsRoute
  '/settings/accounts': typeof appMainLayoutSettingsSettingsAccountsRoute
  '/settings/institutions': typeof appMainLayoutSettingsSettingsInstitutionsRoute
  '/settings/notifications': typeof appMainLayoutSettingsSettingsNotificationsRoute
  '/settings/security': typeof appMainLayoutSettingsSettingsSecurityRoute
  '/settings/users': typeof appMainLayoutSettingsSettingsUsersRoute
  '/settings/webhooks-callbacks': typeof appMainLayoutSettingsSettingsWebhooksCallbacksRoute
  '/transaction-monitoring/$': typeof appMainLayoutTransactionMonitoringTransactionMonitoringSplatRoute
  '/compliance/': typeof appMainLayoutComplianceComplianceIndexRoute
  '/exchange/': typeof appMainLayoutExchangeExchangeIndexRoute
  '/admin/compliance/cases/$caseId': typeof appAdminLayoutAdminComplianceCasesCaseIdRoute
  '/admin/fx/trades/$tradeId': typeof appAdminLayoutAdminFxTradesTradeIdRoute
  '/admin/merchants/$merchantId/$tab': typeof appAdminLayoutAdminMerchantsMerchantIdTabRoute
  '/in-store/agents/$agentId': typeof appMainLayoutInStoreInStoreAgentsAgentIdRouteWithChildren
  '/in-store/agents/$agentId/config': typeof appMainLayoutInStoreInStoreAgentsAgentIdConfigRoute
}
export interface FileRoutesByTo {
  '/about': typeof AboutRoute
  '/account-configuration-error': typeof AccountConfigurationErrorRoute
  '/error': typeof ErrorRoute
  '/auth': typeof AuthAuthLayoutRouteWithChildren
  '/admin': typeof appAdminLayoutAdminRoute
  '/system-status': typeof appMainLayoutSystemStatusRoute
  '/auth/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/auth/signin': typeof AuthAuthLayoutSigninRoute
  '/auth/signup': typeof AuthAuthLayoutSignupRoute
  '/admin/compliance': typeof appAdminLayoutAdminComplianceRouteWithChildren
  '/admin/fx': typeof appAdminLayoutAdminFxRoute
  '/admin/payments': typeof appAdminLayoutAdminPaymentsRoute
  '/balances': typeof appMainLayoutBalancesBalancesRouteWithChildren
  '/labs': typeof appMainLayoutLabsLabsRoute
  '/pay-by-link': typeof appMainLayoutPayByLinkPayByLinkRoute
  '/payments': typeof appMainLayoutPaymentsPaymentsRouteWithChildren
  '/reporting': typeof appMainLayoutReportingReportingRoute
  '/settings': typeof appMainLayoutSettingsSettingsRouteWithChildren
  '/transaction-monitoring': typeof appMainLayoutTransactionMonitoringTransactionMonitoringRouteWithChildren
  '/auth/fx-ai/approve': typeof AuthAuthLayoutFxAiApproveRoute
  '/auth/reset-password/$token': typeof AuthAuthLayoutResetPasswordTokenRoute
  '/auth/set-two-factor/$twoFactorRequestId': typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute
  '/auth/signup/success': typeof AuthAuthLayoutSignupSuccessRoute
  '/auth/verify-otp/$otpRequestId': typeof AuthAuthLayoutVerifyOtpOtpRequestIdRoute
  '/': typeof appMainLayoutDashboardIndexRoute
  '/admin/compliance/cases': typeof appAdminLayoutAdminComplianceCasesRoute
  '/admin/compliance/document-types': typeof appAdminLayoutAdminComplianceDocumentTypesRoute
  '/admin/compliance/overview': typeof appAdminLayoutAdminComplianceOverviewRoute
  '/admin/merchants/$merchantId': typeof appAdminLayoutAdminMerchantsMerchantIdRouteWithChildren
  '/admin/payments/$paymentId': typeof appAdminLayoutAdminPaymentsPaymentIdRoute
  '/balances/overview': typeof appMainLayoutBalancesBalancesOverviewRoute
  '/compliance/action-required': typeof appMainLayoutComplianceComplianceActionRequiredRoute
  '/compliance/approved': typeof appMainLayoutComplianceComplianceApprovedRoute
  '/compliance/closed': typeof appMainLayoutComplianceComplianceClosedRoute
  '/compliance/open': typeof appMainLayoutComplianceComplianceOpenRoute
  '/compliance/rejected': typeof appMainLayoutComplianceComplianceRejectedRoute
  '/compliance/rejected-requirements': typeof appMainLayoutComplianceComplianceRejectedRequirementsRoute
  '/compliance/with-volume': typeof appMainLayoutComplianceComplianceWithVolumeRoute
  '/compliance/$caseId': typeof appMainLayoutComplianceComplianceCaseIdRoute
  '/exchange/mcp-setup': typeof appMainLayoutExchangeExchangeMcpSetupRoute
  '/exchange/notifications': typeof appMainLayoutExchangeExchangeNotificationsRoute
  '/exchange/payouts': typeof appMainLayoutExchangeExchangePayoutsRoute
  '/exchange/trades': typeof appMainLayoutExchangeExchangeTradesRoute
  '/in-store/agents': typeof appMainLayoutInStoreInStoreAgentsRoute
  '/pay-by-link/$paymentIntentId': typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute
  '/payments/payin': typeof appMainLayoutPaymentsPaymentsPayinRoute
  '/payments/payout': typeof appMainLayoutPaymentsPaymentsPayoutRoute
  '/payments/$paymentId': typeof appMainLayoutPaymentsPaymentsPaymentIdRoute
  '/settings/account-settings': typeof appMainLayoutSettingsSettingsAccountSettingsRoute
  '/settings/accounts': typeof appMainLayoutSettingsSettingsAccountsRoute
  '/settings/institutions': typeof appMainLayoutSettingsSettingsInstitutionsRoute
  '/settings/notifications': typeof appMainLayoutSettingsSettingsNotificationsRoute
  '/settings/security': typeof appMainLayoutSettingsSettingsSecurityRoute
  '/settings/users': typeof appMainLayoutSettingsSettingsUsersRoute
  '/settings/webhooks-callbacks': typeof appMainLayoutSettingsSettingsWebhooksCallbacksRoute
  '/transaction-monitoring/$': typeof appMainLayoutTransactionMonitoringTransactionMonitoringSplatRoute
  '/compliance': typeof appMainLayoutComplianceComplianceIndexRoute
  '/exchange': typeof appMainLayoutExchangeExchangeIndexRoute
  '/admin/compliance/cases/$caseId': typeof appAdminLayoutAdminComplianceCasesCaseIdRoute
  '/admin/fx/trades/$tradeId': typeof appAdminLayoutAdminFxTradesTradeIdRoute
  '/admin/merchants/$merchantId/$tab': typeof appAdminLayoutAdminMerchantsMerchantIdTabRoute
  '/in-store/agents/$agentId': typeof appMainLayoutInStoreInStoreAgentsAgentIdRouteWithChildren
  '/in-store/agents/$agentId/config': typeof appMainLayoutInStoreInStoreAgentsAgentIdConfigRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/about': typeof AboutRoute
  '/account-configuration-error': typeof AccountConfigurationErrorRoute
  '/error': typeof ErrorRoute
  '/(app)/_admin-layout': typeof appAdminLayoutRouteWithChildren
  '/(app)/_main-layout': typeof appMainLayoutRouteWithChildren
  '/auth/_auth-layout': typeof AuthAuthLayoutRouteWithChildren
  '/(app)/_admin-layout/admin': typeof appAdminLayoutAdminRoute
  '/(app)/_main-layout/_compliance': typeof appMainLayoutComplianceRouteWithChildren
  '/(app)/_main-layout/system-status': typeof appMainLayoutSystemStatusRoute
  '/auth/_auth-layout/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/auth/_auth-layout/signin': typeof AuthAuthLayoutSigninRoute
  '/auth/_auth-layout/signup_': typeof AuthAuthLayoutSignupRoute
  '/(app)/_admin-layout/admin_/compliance': typeof appAdminLayoutAdminComplianceRouteWithChildren
  '/(app)/_admin-layout/admin_/fx': typeof appAdminLayoutAdminFxRoute
  '/(app)/_admin-layout/admin_/payments': typeof appAdminLayoutAdminPaymentsRoute
  '/(app)/_main-layout/_balances/balances': typeof appMainLayoutBalancesBalancesRouteWithChildren
  '/(app)/_main-layout/_compliance/compliance': typeof appMainLayoutComplianceComplianceRouteWithChildren
  '/(app)/_main-layout/_exchange/exchange': typeof appMainLayoutExchangeExchangeRouteWithChildren
  '/(app)/_main-layout/_labs/labs': typeof appMainLayoutLabsLabsRoute
  '/(app)/_main-layout/_pay-by-link/pay-by-link': typeof appMainLayoutPayByLinkPayByLinkRoute
  '/(app)/_main-layout/_payments/payments': typeof appMainLayoutPaymentsPaymentsRouteWithChildren
  '/(app)/_main-layout/_reporting/reporting': typeof appMainLayoutReportingReportingRoute
  '/(app)/_main-layout/_settings/settings': typeof appMainLayoutSettingsSettingsRouteWithChildren
  '/(app)/_main-layout/_transaction-monitoring/transaction-monitoring': typeof appMainLayoutTransactionMonitoringTransactionMonitoringRouteWithChildren
  '/auth/_auth-layout/fx-ai/approve': typeof AuthAuthLayoutFxAiApproveRoute
  '/auth/_auth-layout/reset-password/$token': typeof AuthAuthLayoutResetPasswordTokenRoute
  '/auth/_auth-layout/set-two-factor/$twoFactorRequestId': typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute
  '/auth/_auth-layout/signup/success': typeof AuthAuthLayoutSignupSuccessRoute
  '/auth/_auth-layout/verify-otp/$otpRequestId': typeof AuthAuthLayoutVerifyOtpOtpRequestIdRoute
  '/(app)/_main-layout/_dashboard/': typeof appMainLayoutDashboardIndexRoute
  '/(app)/_admin-layout/admin_/compliance/cases': typeof appAdminLayoutAdminComplianceCasesRoute
  '/(app)/_admin-layout/admin_/compliance/document-types': typeof appAdminLayoutAdminComplianceDocumentTypesRoute
  '/(app)/_admin-layout/admin_/compliance/overview': typeof appAdminLayoutAdminComplianceOverviewRoute
  '/(app)/_admin-layout/admin_/merchants_/$merchantId': typeof appAdminLayoutAdminMerchantsMerchantIdRouteWithChildren
  '/(app)/_admin-layout/admin_/payments_/$paymentId': typeof appAdminLayoutAdminPaymentsPaymentIdRoute
  '/(app)/_main-layout/_balances/balances/overview': typeof appMainLayoutBalancesBalancesOverviewRoute
  '/(app)/_main-layout/_compliance/compliance/action-required': typeof appMainLayoutComplianceComplianceActionRequiredRoute
  '/(app)/_main-layout/_compliance/compliance/approved': typeof appMainLayoutComplianceComplianceApprovedRoute
  '/(app)/_main-layout/_compliance/compliance/closed': typeof appMainLayoutComplianceComplianceClosedRoute
  '/(app)/_main-layout/_compliance/compliance/open': typeof appMainLayoutComplianceComplianceOpenRoute
  '/(app)/_main-layout/_compliance/compliance/rejected': typeof appMainLayoutComplianceComplianceRejectedRoute
  '/(app)/_main-layout/_compliance/compliance/rejected-requirements': typeof appMainLayoutComplianceComplianceRejectedRequirementsRoute
  '/(app)/_main-layout/_compliance/compliance/with-volume': typeof appMainLayoutComplianceComplianceWithVolumeRoute
  '/(app)/_main-layout/_compliance/compliance_/$caseId': typeof appMainLayoutComplianceComplianceCaseIdRoute
  '/(app)/_main-layout/_exchange/exchange/mcp-setup': typeof appMainLayoutExchangeExchangeMcpSetupRoute
  '/(app)/_main-layout/_exchange/exchange/notifications': typeof appMainLayoutExchangeExchangeNotificationsRoute
  '/(app)/_main-layout/_exchange/exchange/payouts': typeof appMainLayoutExchangeExchangePayoutsRoute
  '/(app)/_main-layout/_exchange/exchange/trades': typeof appMainLayoutExchangeExchangeTradesRoute
  '/(app)/_main-layout/_in-store/in-store/agents': typeof appMainLayoutInStoreInStoreAgentsRoute
  '/(app)/_main-layout/_pay-by-link/pay-by-link_/$paymentIntentId': typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute
  '/(app)/_main-layout/_payments/payments/payin': typeof appMainLayoutPaymentsPaymentsPayinRoute
  '/(app)/_main-layout/_payments/payments/payout': typeof appMainLayoutPaymentsPaymentsPayoutRoute
  '/(app)/_main-layout/_payments/payments_/$paymentId': typeof appMainLayoutPaymentsPaymentsPaymentIdRoute
  '/(app)/_main-layout/_settings/settings/account-settings': typeof appMainLayoutSettingsSettingsAccountSettingsRoute
  '/(app)/_main-layout/_settings/settings/accounts': typeof appMainLayoutSettingsSettingsAccountsRoute
  '/(app)/_main-layout/_settings/settings/institutions': typeof appMainLayoutSettingsSettingsInstitutionsRoute
  '/(app)/_main-layout/_settings/settings/notifications': typeof appMainLayoutSettingsSettingsNotificationsRoute
  '/(app)/_main-layout/_settings/settings/security': typeof appMainLayoutSettingsSettingsSecurityRoute
  '/(app)/_main-layout/_settings/settings/users': typeof appMainLayoutSettingsSettingsUsersRoute
  '/(app)/_main-layout/_settings/settings/webhooks-callbacks': typeof appMainLayoutSettingsSettingsWebhooksCallbacksRoute
  '/(app)/_main-layout/_transaction-monitoring/transaction-monitoring/$': typeof appMainLayoutTransactionMonitoringTransactionMonitoringSplatRoute
  '/(app)/_main-layout/_compliance/compliance/': typeof appMainLayoutComplianceComplianceIndexRoute
  '/(app)/_main-layout/_exchange/exchange/': typeof appMainLayoutExchangeExchangeIndexRoute
  '/(app)/_admin-layout/admin_/compliance_/cases_/$caseId': typeof appAdminLayoutAdminComplianceCasesCaseIdRoute
  '/(app)/_admin-layout/admin_/fx_/trades_/$tradeId': typeof appAdminLayoutAdminFxTradesTradeIdRoute
  '/(app)/_admin-layout/admin_/merchants_/$merchantId/$tab': typeof appAdminLayoutAdminMerchantsMerchantIdTabRoute
  '/(app)/_main-layout/_in-store/in-store/agents_/$agentId': typeof appMainLayoutInStoreInStoreAgentsAgentIdRouteWithChildren
  '/(app)/_main-layout/_in-store/in-store/agents_/$agentId/config': typeof appMainLayoutInStoreInStoreAgentsAgentIdConfigRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/about'
    | '/account-configuration-error'
    | '/error'
    | '/auth'
    | '/admin'
    | '/system-status'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/admin/compliance'
    | '/admin/fx'
    | '/admin/payments'
    | '/balances'
    | '/compliance'
    | '/exchange'
    | '/labs'
    | '/pay-by-link'
    | '/payments'
    | '/reporting'
    | '/settings'
    | '/transaction-monitoring'
    | '/auth/fx-ai/approve'
    | '/auth/reset-password/$token'
    | '/auth/set-two-factor/$twoFactorRequestId'
    | '/auth/signup/success'
    | '/auth/verify-otp/$otpRequestId'
    | '/'
    | '/admin/compliance/cases'
    | '/admin/compliance/document-types'
    | '/admin/compliance/overview'
    | '/admin/merchants/$merchantId'
    | '/admin/payments/$paymentId'
    | '/balances/overview'
    | '/compliance/action-required'
    | '/compliance/approved'
    | '/compliance/closed'
    | '/compliance/open'
    | '/compliance/rejected'
    | '/compliance/rejected-requirements'
    | '/compliance/with-volume'
    | '/compliance/$caseId'
    | '/exchange/mcp-setup'
    | '/exchange/notifications'
    | '/exchange/payouts'
    | '/exchange/trades'
    | '/in-store/agents'
    | '/pay-by-link/$paymentIntentId'
    | '/payments/payin'
    | '/payments/payout'
    | '/payments/$paymentId'
    | '/settings/account-settings'
    | '/settings/accounts'
    | '/settings/institutions'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/users'
    | '/settings/webhooks-callbacks'
    | '/transaction-monitoring/$'
    | '/compliance/'
    | '/exchange/'
    | '/admin/compliance/cases/$caseId'
    | '/admin/fx/trades/$tradeId'
    | '/admin/merchants/$merchantId/$tab'
    | '/in-store/agents/$agentId'
    | '/in-store/agents/$agentId/config'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about'
    | '/account-configuration-error'
    | '/error'
    | '/auth'
    | '/admin'
    | '/system-status'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/admin/compliance'
    | '/admin/fx'
    | '/admin/payments'
    | '/balances'
    | '/labs'
    | '/pay-by-link'
    | '/payments'
    | '/reporting'
    | '/settings'
    | '/transaction-monitoring'
    | '/auth/fx-ai/approve'
    | '/auth/reset-password/$token'
    | '/auth/set-two-factor/$twoFactorRequestId'
    | '/auth/signup/success'
    | '/auth/verify-otp/$otpRequestId'
    | '/'
    | '/admin/compliance/cases'
    | '/admin/compliance/document-types'
    | '/admin/compliance/overview'
    | '/admin/merchants/$merchantId'
    | '/admin/payments/$paymentId'
    | '/balances/overview'
    | '/compliance/action-required'
    | '/compliance/approved'
    | '/compliance/closed'
    | '/compliance/open'
    | '/compliance/rejected'
    | '/compliance/rejected-requirements'
    | '/compliance/with-volume'
    | '/compliance/$caseId'
    | '/exchange/mcp-setup'
    | '/exchange/notifications'
    | '/exchange/payouts'
    | '/exchange/trades'
    | '/in-store/agents'
    | '/pay-by-link/$paymentIntentId'
    | '/payments/payin'
    | '/payments/payout'
    | '/payments/$paymentId'
    | '/settings/account-settings'
    | '/settings/accounts'
    | '/settings/institutions'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/users'
    | '/settings/webhooks-callbacks'
    | '/transaction-monitoring/$'
    | '/compliance'
    | '/exchange'
    | '/admin/compliance/cases/$caseId'
    | '/admin/fx/trades/$tradeId'
    | '/admin/merchants/$merchantId/$tab'
    | '/in-store/agents/$agentId'
    | '/in-store/agents/$agentId/config'
  id:
    | '__root__'
    | '/about'
    | '/account-configuration-error'
    | '/error'
    | '/(app)/_admin-layout'
    | '/(app)/_main-layout'
    | '/auth/_auth-layout'
    | '/(app)/_admin-layout/admin'
    | '/(app)/_main-layout/_compliance'
    | '/(app)/_main-layout/system-status'
    | '/auth/_auth-layout/forgot-password'
    | '/auth/_auth-layout/signin'
    | '/auth/_auth-layout/signup_'
    | '/(app)/_admin-layout/admin_/compliance'
    | '/(app)/_admin-layout/admin_/fx'
    | '/(app)/_admin-layout/admin_/payments'
    | '/(app)/_main-layout/_balances/balances'
    | '/(app)/_main-layout/_compliance/compliance'
    | '/(app)/_main-layout/_exchange/exchange'
    | '/(app)/_main-layout/_labs/labs'
    | '/(app)/_main-layout/_pay-by-link/pay-by-link'
    | '/(app)/_main-layout/_payments/payments'
    | '/(app)/_main-layout/_reporting/reporting'
    | '/(app)/_main-layout/_settings/settings'
    | '/(app)/_main-layout/_transaction-monitoring/transaction-monitoring'
    | '/auth/_auth-layout/fx-ai/approve'
    | '/auth/_auth-layout/reset-password/$token'
    | '/auth/_auth-layout/set-two-factor/$twoFactorRequestId'
    | '/auth/_auth-layout/signup/success'
    | '/auth/_auth-layout/verify-otp/$otpRequestId'
    | '/(app)/_main-layout/_dashboard/'
    | '/(app)/_admin-layout/admin_/compliance/cases'
    | '/(app)/_admin-layout/admin_/compliance/document-types'
    | '/(app)/_admin-layout/admin_/compliance/overview'
    | '/(app)/_admin-layout/admin_/merchants_/$merchantId'
    | '/(app)/_admin-layout/admin_/payments_/$paymentId'
    | '/(app)/_main-layout/_balances/balances/overview'
    | '/(app)/_main-layout/_compliance/compliance/action-required'
    | '/(app)/_main-layout/_compliance/compliance/approved'
    | '/(app)/_main-layout/_compliance/compliance/closed'
    | '/(app)/_main-layout/_compliance/compliance/open'
    | '/(app)/_main-layout/_compliance/compliance/rejected'
    | '/(app)/_main-layout/_compliance/compliance/rejected-requirements'
    | '/(app)/_main-layout/_compliance/compliance/with-volume'
    | '/(app)/_main-layout/_compliance/compliance_/$caseId'
    | '/(app)/_main-layout/_exchange/exchange/mcp-setup'
    | '/(app)/_main-layout/_exchange/exchange/notifications'
    | '/(app)/_main-layout/_exchange/exchange/payouts'
    | '/(app)/_main-layout/_exchange/exchange/trades'
    | '/(app)/_main-layout/_in-store/in-store/agents'
    | '/(app)/_main-layout/_pay-by-link/pay-by-link_/$paymentIntentId'
    | '/(app)/_main-layout/_payments/payments/payin'
    | '/(app)/_main-layout/_payments/payments/payout'
    | '/(app)/_main-layout/_payments/payments_/$paymentId'
    | '/(app)/_main-layout/_settings/settings/account-settings'
    | '/(app)/_main-layout/_settings/settings/accounts'
    | '/(app)/_main-layout/_settings/settings/institutions'
    | '/(app)/_main-layout/_settings/settings/notifications'
    | '/(app)/_main-layout/_settings/settings/security'
    | '/(app)/_main-layout/_settings/settings/users'
    | '/(app)/_main-layout/_settings/settings/webhooks-callbacks'
    | '/(app)/_main-layout/_transaction-monitoring/transaction-monitoring/$'
    | '/(app)/_main-layout/_compliance/compliance/'
    | '/(app)/_main-layout/_exchange/exchange/'
    | '/(app)/_admin-layout/admin_/compliance_/cases_/$caseId'
    | '/(app)/_admin-layout/admin_/fx_/trades_/$tradeId'
    | '/(app)/_admin-layout/admin_/merchants_/$merchantId/$tab'
    | '/(app)/_main-layout/_in-store/in-store/agents_/$agentId'
    | '/(app)/_main-layout/_in-store/in-store/agents_/$agentId/config'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AboutRoute: typeof AboutRoute
  AccountConfigurationErrorRoute: typeof AccountConfigurationErrorRoute
  ErrorRoute: typeof ErrorRoute
  appAdminLayoutRoute: typeof appAdminLayoutRouteWithChildren
  appMainLayoutRoute: typeof appMainLayoutRouteWithChildren
  AuthAuthLayoutRoute: typeof AuthAuthLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-configuration-error': {
      id: '/account-configuration-error'
      path: '/account-configuration-error'
      fullPath: '/account-configuration-error'
      preLoaderRoute: typeof AccountConfigurationErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/_admin-layout': {
      id: '/(app)/_admin-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appAdminLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/_main-layout': {
      id: '/(app)/_main-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appMainLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/_auth-layout': {
      id: '/auth/_auth-layout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthAuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/_admin-layout/admin': {
      id: '/(app)/_admin-layout/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof appAdminLayoutAdminRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_main-layout/_compliance': {
      id: '/(app)/_main-layout/_compliance'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appMainLayoutComplianceRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/system-status': {
      id: '/(app)/_main-layout/system-status'
      path: '/system-status'
      fullPath: '/system-status'
      preLoaderRoute: typeof appMainLayoutSystemStatusRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/auth/_auth-layout/forgot-password': {
      id: '/auth/_auth-layout/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthAuthLayoutForgotPasswordRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/signin': {
      id: '/auth/_auth-layout/signin'
      path: '/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthAuthLayoutSigninRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/signup_': {
      id: '/auth/_auth-layout/signup_'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthAuthLayoutSignupRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/(app)/_admin-layout/admin_/compliance': {
      id: '/(app)/_admin-layout/admin_/compliance'
      path: '/admin/compliance'
      fullPath: '/admin/compliance'
      preLoaderRoute: typeof appAdminLayoutAdminComplianceRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_admin-layout/admin_/fx': {
      id: '/(app)/_admin-layout/admin_/fx'
      path: '/admin/fx'
      fullPath: '/admin/fx'
      preLoaderRoute: typeof appAdminLayoutAdminFxRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_admin-layout/admin_/payments': {
      id: '/(app)/_admin-layout/admin_/payments'
      path: '/admin/payments'
      fullPath: '/admin/payments'
      preLoaderRoute: typeof appAdminLayoutAdminPaymentsRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_main-layout/_balances/balances': {
      id: '/(app)/_main-layout/_balances/balances'
      path: '/balances'
      fullPath: '/balances'
      preLoaderRoute: typeof appMainLayoutBalancesBalancesRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_compliance/compliance': {
      id: '/(app)/_main-layout/_compliance/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceRouteImport
      parentRoute: typeof appMainLayoutComplianceRoute
    }
    '/(app)/_main-layout/_dashboard/': {
      id: '/(app)/_main-layout/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appMainLayoutDashboardIndexRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_exchange/exchange': {
      id: '/(app)/_main-layout/_exchange/exchange'
      path: '/exchange'
      fullPath: '/exchange'
      preLoaderRoute: typeof appMainLayoutExchangeExchangeRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_labs/labs': {
      id: '/(app)/_main-layout/_labs/labs'
      path: '/labs'
      fullPath: '/labs'
      preLoaderRoute: typeof appMainLayoutLabsLabsRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_pay-by-link/pay-by-link': {
      id: '/(app)/_main-layout/_pay-by-link/pay-by-link'
      path: '/pay-by-link'
      fullPath: '/pay-by-link'
      preLoaderRoute: typeof appMainLayoutPayByLinkPayByLinkRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_payments/payments': {
      id: '/(app)/_main-layout/_payments/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof appMainLayoutPaymentsPaymentsRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_reporting/reporting': {
      id: '/(app)/_main-layout/_reporting/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof appMainLayoutReportingReportingRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_settings/settings': {
      id: '/(app)/_main-layout/_settings/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_transaction-monitoring/transaction-monitoring': {
      id: '/(app)/_main-layout/_transaction-monitoring/transaction-monitoring'
      path: '/transaction-monitoring'
      fullPath: '/transaction-monitoring'
      preLoaderRoute: typeof appMainLayoutTransactionMonitoringTransactionMonitoringRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/auth/_auth-layout/fx-ai/approve': {
      id: '/auth/_auth-layout/fx-ai/approve'
      path: '/fx-ai/approve'
      fullPath: '/auth/fx-ai/approve'
      preLoaderRoute: typeof AuthAuthLayoutFxAiApproveRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/reset-password/$token': {
      id: '/auth/_auth-layout/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/auth/reset-password/$token'
      preLoaderRoute: typeof AuthAuthLayoutResetPasswordTokenRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/set-two-factor/$twoFactorRequestId': {
      id: '/auth/_auth-layout/set-two-factor/$twoFactorRequestId'
      path: '/set-two-factor/$twoFactorRequestId'
      fullPath: '/auth/set-two-factor/$twoFactorRequestId'
      preLoaderRoute: typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/signup/success': {
      id: '/auth/_auth-layout/signup/success'
      path: '/signup/success'
      fullPath: '/auth/signup/success'
      preLoaderRoute: typeof AuthAuthLayoutSignupSuccessRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/verify-otp/$otpRequestId': {
      id: '/auth/_auth-layout/verify-otp/$otpRequestId'
      path: '/verify-otp/$otpRequestId'
      fullPath: '/auth/verify-otp/$otpRequestId'
      preLoaderRoute: typeof AuthAuthLayoutVerifyOtpOtpRequestIdRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/(app)/_admin-layout/admin_/compliance/cases': {
      id: '/(app)/_admin-layout/admin_/compliance/cases'
      path: '/cases'
      fullPath: '/admin/compliance/cases'
      preLoaderRoute: typeof appAdminLayoutAdminComplianceCasesRouteImport
      parentRoute: typeof appAdminLayoutAdminComplianceRoute
    }
    '/(app)/_admin-layout/admin_/compliance/document-types': {
      id: '/(app)/_admin-layout/admin_/compliance/document-types'
      path: '/document-types'
      fullPath: '/admin/compliance/document-types'
      preLoaderRoute: typeof appAdminLayoutAdminComplianceDocumentTypesRouteImport
      parentRoute: typeof appAdminLayoutAdminComplianceRoute
    }
    '/(app)/_admin-layout/admin_/compliance/overview': {
      id: '/(app)/_admin-layout/admin_/compliance/overview'
      path: '/overview'
      fullPath: '/admin/compliance/overview'
      preLoaderRoute: typeof appAdminLayoutAdminComplianceOverviewRouteImport
      parentRoute: typeof appAdminLayoutAdminComplianceRoute
    }
    '/(app)/_admin-layout/admin_/merchants_/$merchantId': {
      id: '/(app)/_admin-layout/admin_/merchants_/$merchantId'
      path: '/admin/merchants/$merchantId'
      fullPath: '/admin/merchants/$merchantId'
      preLoaderRoute: typeof appAdminLayoutAdminMerchantsMerchantIdRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_admin-layout/admin_/payments_/$paymentId': {
      id: '/(app)/_admin-layout/admin_/payments_/$paymentId'
      path: '/admin/payments/$paymentId'
      fullPath: '/admin/payments/$paymentId'
      preLoaderRoute: typeof appAdminLayoutAdminPaymentsPaymentIdRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_main-layout/_balances/balances/overview': {
      id: '/(app)/_main-layout/_balances/balances/overview'
      path: '/overview'
      fullPath: '/balances/overview'
      preLoaderRoute: typeof appMainLayoutBalancesBalancesOverviewRouteImport
      parentRoute: typeof appMainLayoutBalancesBalancesRoute
    }
    '/(app)/_main-layout/_compliance/compliance/': {
      id: '/(app)/_main-layout/_compliance/compliance/'
      path: '/'
      fullPath: '/compliance/'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceIndexRouteImport
      parentRoute: typeof appMainLayoutComplianceComplianceRoute
    }
    '/(app)/_main-layout/_compliance/compliance/action-required': {
      id: '/(app)/_main-layout/_compliance/compliance/action-required'
      path: '/action-required'
      fullPath: '/compliance/action-required'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceActionRequiredRouteImport
      parentRoute: typeof appMainLayoutComplianceComplianceRoute
    }
    '/(app)/_main-layout/_compliance/compliance/approved': {
      id: '/(app)/_main-layout/_compliance/compliance/approved'
      path: '/approved'
      fullPath: '/compliance/approved'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceApprovedRouteImport
      parentRoute: typeof appMainLayoutComplianceComplianceRoute
    }
    '/(app)/_main-layout/_compliance/compliance/closed': {
      id: '/(app)/_main-layout/_compliance/compliance/closed'
      path: '/closed'
      fullPath: '/compliance/closed'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceClosedRouteImport
      parentRoute: typeof appMainLayoutComplianceComplianceRoute
    }
    '/(app)/_main-layout/_compliance/compliance/open': {
      id: '/(app)/_main-layout/_compliance/compliance/open'
      path: '/open'
      fullPath: '/compliance/open'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceOpenRouteImport
      parentRoute: typeof appMainLayoutComplianceComplianceRoute
    }
    '/(app)/_main-layout/_compliance/compliance/rejected': {
      id: '/(app)/_main-layout/_compliance/compliance/rejected'
      path: '/rejected'
      fullPath: '/compliance/rejected'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceRejectedRouteImport
      parentRoute: typeof appMainLayoutComplianceComplianceRoute
    }
    '/(app)/_main-layout/_compliance/compliance/rejected-requirements': {
      id: '/(app)/_main-layout/_compliance/compliance/rejected-requirements'
      path: '/rejected-requirements'
      fullPath: '/compliance/rejected-requirements'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceRejectedRequirementsRouteImport
      parentRoute: typeof appMainLayoutComplianceComplianceRoute
    }
    '/(app)/_main-layout/_compliance/compliance/with-volume': {
      id: '/(app)/_main-layout/_compliance/compliance/with-volume'
      path: '/with-volume'
      fullPath: '/compliance/with-volume'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceWithVolumeRouteImport
      parentRoute: typeof appMainLayoutComplianceComplianceRoute
    }
    '/(app)/_main-layout/_compliance/compliance_/$caseId': {
      id: '/(app)/_main-layout/_compliance/compliance_/$caseId'
      path: '/compliance/$caseId'
      fullPath: '/compliance/$caseId'
      preLoaderRoute: typeof appMainLayoutComplianceComplianceCaseIdRouteImport
      parentRoute: typeof appMainLayoutComplianceRoute
    }
    '/(app)/_main-layout/_exchange/exchange/': {
      id: '/(app)/_main-layout/_exchange/exchange/'
      path: '/'
      fullPath: '/exchange/'
      preLoaderRoute: typeof appMainLayoutExchangeExchangeIndexRouteImport
      parentRoute: typeof appMainLayoutExchangeExchangeRoute
    }
    '/(app)/_main-layout/_exchange/exchange/mcp-setup': {
      id: '/(app)/_main-layout/_exchange/exchange/mcp-setup'
      path: '/mcp-setup'
      fullPath: '/exchange/mcp-setup'
      preLoaderRoute: typeof appMainLayoutExchangeExchangeMcpSetupRouteImport
      parentRoute: typeof appMainLayoutExchangeExchangeRoute
    }
    '/(app)/_main-layout/_exchange/exchange/notifications': {
      id: '/(app)/_main-layout/_exchange/exchange/notifications'
      path: '/notifications'
      fullPath: '/exchange/notifications'
      preLoaderRoute: typeof appMainLayoutExchangeExchangeNotificationsRouteImport
      parentRoute: typeof appMainLayoutExchangeExchangeRoute
    }
    '/(app)/_main-layout/_exchange/exchange/payouts': {
      id: '/(app)/_main-layout/_exchange/exchange/payouts'
      path: '/payouts'
      fullPath: '/exchange/payouts'
      preLoaderRoute: typeof appMainLayoutExchangeExchangePayoutsRouteImport
      parentRoute: typeof appMainLayoutExchangeExchangeRoute
    }
    '/(app)/_main-layout/_exchange/exchange/trades': {
      id: '/(app)/_main-layout/_exchange/exchange/trades'
      path: '/trades'
      fullPath: '/exchange/trades'
      preLoaderRoute: typeof appMainLayoutExchangeExchangeTradesRouteImport
      parentRoute: typeof appMainLayoutExchangeExchangeRoute
    }
    '/(app)/_main-layout/_in-store/in-store/agents': {
      id: '/(app)/_main-layout/_in-store/in-store/agents'
      path: '/in-store/agents'
      fullPath: '/in-store/agents'
      preLoaderRoute: typeof appMainLayoutInStoreInStoreAgentsRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_pay-by-link/pay-by-link_/$paymentIntentId': {
      id: '/(app)/_main-layout/_pay-by-link/pay-by-link_/$paymentIntentId'
      path: '/pay-by-link/$paymentIntentId'
      fullPath: '/pay-by-link/$paymentIntentId'
      preLoaderRoute: typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_payments/payments/payin': {
      id: '/(app)/_main-layout/_payments/payments/payin'
      path: '/payin'
      fullPath: '/payments/payin'
      preLoaderRoute: typeof appMainLayoutPaymentsPaymentsPayinRouteImport
      parentRoute: typeof appMainLayoutPaymentsPaymentsRoute
    }
    '/(app)/_main-layout/_payments/payments/payout': {
      id: '/(app)/_main-layout/_payments/payments/payout'
      path: '/payout'
      fullPath: '/payments/payout'
      preLoaderRoute: typeof appMainLayoutPaymentsPaymentsPayoutRouteImport
      parentRoute: typeof appMainLayoutPaymentsPaymentsRoute
    }
    '/(app)/_main-layout/_payments/payments_/$paymentId': {
      id: '/(app)/_main-layout/_payments/payments_/$paymentId'
      path: '/payments/$paymentId'
      fullPath: '/payments/$paymentId'
      preLoaderRoute: typeof appMainLayoutPaymentsPaymentsPaymentIdRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_settings/settings/account-settings': {
      id: '/(app)/_main-layout/_settings/settings/account-settings'
      path: '/account-settings'
      fullPath: '/settings/account-settings'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsAccountSettingsRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/accounts': {
      id: '/(app)/_main-layout/_settings/settings/accounts'
      path: '/accounts'
      fullPath: '/settings/accounts'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsAccountsRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/institutions': {
      id: '/(app)/_main-layout/_settings/settings/institutions'
      path: '/institutions'
      fullPath: '/settings/institutions'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsInstitutionsRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/notifications': {
      id: '/(app)/_main-layout/_settings/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsNotificationsRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/security': {
      id: '/(app)/_main-layout/_settings/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsSecurityRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/users': {
      id: '/(app)/_main-layout/_settings/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsUsersRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/webhooks-callbacks': {
      id: '/(app)/_main-layout/_settings/settings/webhooks-callbacks'
      path: '/webhooks-callbacks'
      fullPath: '/settings/webhooks-callbacks'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsWebhooksCallbacksRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_transaction-monitoring/transaction-monitoring/$': {
      id: '/(app)/_main-layout/_transaction-monitoring/transaction-monitoring/$'
      path: '/$'
      fullPath: '/transaction-monitoring/$'
      preLoaderRoute: typeof appMainLayoutTransactionMonitoringTransactionMonitoringSplatRouteImport
      parentRoute: typeof appMainLayoutTransactionMonitoringTransactionMonitoringRoute
    }
    '/(app)/_admin-layout/admin_/compliance_/cases_/$caseId': {
      id: '/(app)/_admin-layout/admin_/compliance_/cases_/$caseId'
      path: '/admin/compliance/cases/$caseId'
      fullPath: '/admin/compliance/cases/$caseId'
      preLoaderRoute: typeof appAdminLayoutAdminComplianceCasesCaseIdRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_admin-layout/admin_/fx_/trades_/$tradeId': {
      id: '/(app)/_admin-layout/admin_/fx_/trades_/$tradeId'
      path: '/admin/fx/trades/$tradeId'
      fullPath: '/admin/fx/trades/$tradeId'
      preLoaderRoute: typeof appAdminLayoutAdminFxTradesTradeIdRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_admin-layout/admin_/merchants_/$merchantId/$tab': {
      id: '/(app)/_admin-layout/admin_/merchants_/$merchantId/$tab'
      path: '/$tab'
      fullPath: '/admin/merchants/$merchantId/$tab'
      preLoaderRoute: typeof appAdminLayoutAdminMerchantsMerchantIdTabRouteImport
      parentRoute: typeof appAdminLayoutAdminMerchantsMerchantIdRoute
    }
    '/(app)/_main-layout/_in-store/in-store/agents_/$agentId': {
      id: '/(app)/_main-layout/_in-store/in-store/agents_/$agentId'
      path: '/in-store/agents/$agentId'
      fullPath: '/in-store/agents/$agentId'
      preLoaderRoute: typeof appMainLayoutInStoreInStoreAgentsAgentIdRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_in-store/in-store/agents_/$agentId/config': {
      id: '/(app)/_main-layout/_in-store/in-store/agents_/$agentId/config'
      path: '/config'
      fullPath: '/in-store/agents/$agentId/config'
      preLoaderRoute: typeof appMainLayoutInStoreInStoreAgentsAgentIdConfigRouteImport
      parentRoute: typeof appMainLayoutInStoreInStoreAgentsAgentIdRoute
    }
  }
}

interface appAdminLayoutAdminComplianceRouteChildren {
  appAdminLayoutAdminComplianceCasesRoute: typeof appAdminLayoutAdminComplianceCasesRoute
  appAdminLayoutAdminComplianceDocumentTypesRoute: typeof appAdminLayoutAdminComplianceDocumentTypesRoute
  appAdminLayoutAdminComplianceOverviewRoute: typeof appAdminLayoutAdminComplianceOverviewRoute
}

const appAdminLayoutAdminComplianceRouteChildren: appAdminLayoutAdminComplianceRouteChildren =
  {
    appAdminLayoutAdminComplianceCasesRoute:
      appAdminLayoutAdminComplianceCasesRoute,
    appAdminLayoutAdminComplianceDocumentTypesRoute:
      appAdminLayoutAdminComplianceDocumentTypesRoute,
    appAdminLayoutAdminComplianceOverviewRoute:
      appAdminLayoutAdminComplianceOverviewRoute,
  }

const appAdminLayoutAdminComplianceRouteWithChildren =
  appAdminLayoutAdminComplianceRoute._addFileChildren(
    appAdminLayoutAdminComplianceRouteChildren,
  )

interface appAdminLayoutAdminMerchantsMerchantIdRouteChildren {
  appAdminLayoutAdminMerchantsMerchantIdTabRoute: typeof appAdminLayoutAdminMerchantsMerchantIdTabRoute
}

const appAdminLayoutAdminMerchantsMerchantIdRouteChildren: appAdminLayoutAdminMerchantsMerchantIdRouteChildren =
  {
    appAdminLayoutAdminMerchantsMerchantIdTabRoute:
      appAdminLayoutAdminMerchantsMerchantIdTabRoute,
  }

const appAdminLayoutAdminMerchantsMerchantIdRouteWithChildren =
  appAdminLayoutAdminMerchantsMerchantIdRoute._addFileChildren(
    appAdminLayoutAdminMerchantsMerchantIdRouteChildren,
  )

interface appAdminLayoutRouteChildren {
  appAdminLayoutAdminRoute: typeof appAdminLayoutAdminRoute
  appAdminLayoutAdminComplianceRoute: typeof appAdminLayoutAdminComplianceRouteWithChildren
  appAdminLayoutAdminFxRoute: typeof appAdminLayoutAdminFxRoute
  appAdminLayoutAdminPaymentsRoute: typeof appAdminLayoutAdminPaymentsRoute
  appAdminLayoutAdminMerchantsMerchantIdRoute: typeof appAdminLayoutAdminMerchantsMerchantIdRouteWithChildren
  appAdminLayoutAdminPaymentsPaymentIdRoute: typeof appAdminLayoutAdminPaymentsPaymentIdRoute
  appAdminLayoutAdminComplianceCasesCaseIdRoute: typeof appAdminLayoutAdminComplianceCasesCaseIdRoute
  appAdminLayoutAdminFxTradesTradeIdRoute: typeof appAdminLayoutAdminFxTradesTradeIdRoute
}

const appAdminLayoutRouteChildren: appAdminLayoutRouteChildren = {
  appAdminLayoutAdminRoute: appAdminLayoutAdminRoute,
  appAdminLayoutAdminComplianceRoute:
    appAdminLayoutAdminComplianceRouteWithChildren,
  appAdminLayoutAdminFxRoute: appAdminLayoutAdminFxRoute,
  appAdminLayoutAdminPaymentsRoute: appAdminLayoutAdminPaymentsRoute,
  appAdminLayoutAdminMerchantsMerchantIdRoute:
    appAdminLayoutAdminMerchantsMerchantIdRouteWithChildren,
  appAdminLayoutAdminPaymentsPaymentIdRoute:
    appAdminLayoutAdminPaymentsPaymentIdRoute,
  appAdminLayoutAdminComplianceCasesCaseIdRoute:
    appAdminLayoutAdminComplianceCasesCaseIdRoute,
  appAdminLayoutAdminFxTradesTradeIdRoute:
    appAdminLayoutAdminFxTradesTradeIdRoute,
}

const appAdminLayoutRouteWithChildren = appAdminLayoutRoute._addFileChildren(
  appAdminLayoutRouteChildren,
)

interface appMainLayoutComplianceComplianceRouteChildren {
  appMainLayoutComplianceComplianceActionRequiredRoute: typeof appMainLayoutComplianceComplianceActionRequiredRoute
  appMainLayoutComplianceComplianceApprovedRoute: typeof appMainLayoutComplianceComplianceApprovedRoute
  appMainLayoutComplianceComplianceClosedRoute: typeof appMainLayoutComplianceComplianceClosedRoute
  appMainLayoutComplianceComplianceOpenRoute: typeof appMainLayoutComplianceComplianceOpenRoute
  appMainLayoutComplianceComplianceRejectedRoute: typeof appMainLayoutComplianceComplianceRejectedRoute
  appMainLayoutComplianceComplianceRejectedRequirementsRoute: typeof appMainLayoutComplianceComplianceRejectedRequirementsRoute
  appMainLayoutComplianceComplianceWithVolumeRoute: typeof appMainLayoutComplianceComplianceWithVolumeRoute
  appMainLayoutComplianceComplianceIndexRoute: typeof appMainLayoutComplianceComplianceIndexRoute
}

const appMainLayoutComplianceComplianceRouteChildren: appMainLayoutComplianceComplianceRouteChildren =
  {
    appMainLayoutComplianceComplianceActionRequiredRoute:
      appMainLayoutComplianceComplianceActionRequiredRoute,
    appMainLayoutComplianceComplianceApprovedRoute:
      appMainLayoutComplianceComplianceApprovedRoute,
    appMainLayoutComplianceComplianceClosedRoute:
      appMainLayoutComplianceComplianceClosedRoute,
    appMainLayoutComplianceComplianceOpenRoute:
      appMainLayoutComplianceComplianceOpenRoute,
    appMainLayoutComplianceComplianceRejectedRoute:
      appMainLayoutComplianceComplianceRejectedRoute,
    appMainLayoutComplianceComplianceRejectedRequirementsRoute:
      appMainLayoutComplianceComplianceRejectedRequirementsRoute,
    appMainLayoutComplianceComplianceWithVolumeRoute:
      appMainLayoutComplianceComplianceWithVolumeRoute,
    appMainLayoutComplianceComplianceIndexRoute:
      appMainLayoutComplianceComplianceIndexRoute,
  }

const appMainLayoutComplianceComplianceRouteWithChildren =
  appMainLayoutComplianceComplianceRoute._addFileChildren(
    appMainLayoutComplianceComplianceRouteChildren,
  )

interface appMainLayoutComplianceRouteChildren {
  appMainLayoutComplianceComplianceRoute: typeof appMainLayoutComplianceComplianceRouteWithChildren
  appMainLayoutComplianceComplianceCaseIdRoute: typeof appMainLayoutComplianceComplianceCaseIdRoute
}

const appMainLayoutComplianceRouteChildren: appMainLayoutComplianceRouteChildren =
  {
    appMainLayoutComplianceComplianceRoute:
      appMainLayoutComplianceComplianceRouteWithChildren,
    appMainLayoutComplianceComplianceCaseIdRoute:
      appMainLayoutComplianceComplianceCaseIdRoute,
  }

const appMainLayoutComplianceRouteWithChildren =
  appMainLayoutComplianceRoute._addFileChildren(
    appMainLayoutComplianceRouteChildren,
  )

interface appMainLayoutBalancesBalancesRouteChildren {
  appMainLayoutBalancesBalancesOverviewRoute: typeof appMainLayoutBalancesBalancesOverviewRoute
}

const appMainLayoutBalancesBalancesRouteChildren: appMainLayoutBalancesBalancesRouteChildren =
  {
    appMainLayoutBalancesBalancesOverviewRoute:
      appMainLayoutBalancesBalancesOverviewRoute,
  }

const appMainLayoutBalancesBalancesRouteWithChildren =
  appMainLayoutBalancesBalancesRoute._addFileChildren(
    appMainLayoutBalancesBalancesRouteChildren,
  )

interface appMainLayoutExchangeExchangeRouteChildren {
  appMainLayoutExchangeExchangeMcpSetupRoute: typeof appMainLayoutExchangeExchangeMcpSetupRoute
  appMainLayoutExchangeExchangeNotificationsRoute: typeof appMainLayoutExchangeExchangeNotificationsRoute
  appMainLayoutExchangeExchangePayoutsRoute: typeof appMainLayoutExchangeExchangePayoutsRoute
  appMainLayoutExchangeExchangeTradesRoute: typeof appMainLayoutExchangeExchangeTradesRoute
  appMainLayoutExchangeExchangeIndexRoute: typeof appMainLayoutExchangeExchangeIndexRoute
}

const appMainLayoutExchangeExchangeRouteChildren: appMainLayoutExchangeExchangeRouteChildren =
  {
    appMainLayoutExchangeExchangeMcpSetupRoute:
      appMainLayoutExchangeExchangeMcpSetupRoute,
    appMainLayoutExchangeExchangeNotificationsRoute:
      appMainLayoutExchangeExchangeNotificationsRoute,
    appMainLayoutExchangeExchangePayoutsRoute:
      appMainLayoutExchangeExchangePayoutsRoute,
    appMainLayoutExchangeExchangeTradesRoute:
      appMainLayoutExchangeExchangeTradesRoute,
    appMainLayoutExchangeExchangeIndexRoute:
      appMainLayoutExchangeExchangeIndexRoute,
  }

const appMainLayoutExchangeExchangeRouteWithChildren =
  appMainLayoutExchangeExchangeRoute._addFileChildren(
    appMainLayoutExchangeExchangeRouteChildren,
  )

interface appMainLayoutPaymentsPaymentsRouteChildren {
  appMainLayoutPaymentsPaymentsPayinRoute: typeof appMainLayoutPaymentsPaymentsPayinRoute
  appMainLayoutPaymentsPaymentsPayoutRoute: typeof appMainLayoutPaymentsPaymentsPayoutRoute
}

const appMainLayoutPaymentsPaymentsRouteChildren: appMainLayoutPaymentsPaymentsRouteChildren =
  {
    appMainLayoutPaymentsPaymentsPayinRoute:
      appMainLayoutPaymentsPaymentsPayinRoute,
    appMainLayoutPaymentsPaymentsPayoutRoute:
      appMainLayoutPaymentsPaymentsPayoutRoute,
  }

const appMainLayoutPaymentsPaymentsRouteWithChildren =
  appMainLayoutPaymentsPaymentsRoute._addFileChildren(
    appMainLayoutPaymentsPaymentsRouteChildren,
  )

interface appMainLayoutSettingsSettingsRouteChildren {
  appMainLayoutSettingsSettingsAccountSettingsRoute: typeof appMainLayoutSettingsSettingsAccountSettingsRoute
  appMainLayoutSettingsSettingsAccountsRoute: typeof appMainLayoutSettingsSettingsAccountsRoute
  appMainLayoutSettingsSettingsInstitutionsRoute: typeof appMainLayoutSettingsSettingsInstitutionsRoute
  appMainLayoutSettingsSettingsNotificationsRoute: typeof appMainLayoutSettingsSettingsNotificationsRoute
  appMainLayoutSettingsSettingsSecurityRoute: typeof appMainLayoutSettingsSettingsSecurityRoute
  appMainLayoutSettingsSettingsUsersRoute: typeof appMainLayoutSettingsSettingsUsersRoute
  appMainLayoutSettingsSettingsWebhooksCallbacksRoute: typeof appMainLayoutSettingsSettingsWebhooksCallbacksRoute
}

const appMainLayoutSettingsSettingsRouteChildren: appMainLayoutSettingsSettingsRouteChildren =
  {
    appMainLayoutSettingsSettingsAccountSettingsRoute:
      appMainLayoutSettingsSettingsAccountSettingsRoute,
    appMainLayoutSettingsSettingsAccountsRoute:
      appMainLayoutSettingsSettingsAccountsRoute,
    appMainLayoutSettingsSettingsInstitutionsRoute:
      appMainLayoutSettingsSettingsInstitutionsRoute,
    appMainLayoutSettingsSettingsNotificationsRoute:
      appMainLayoutSettingsSettingsNotificationsRoute,
    appMainLayoutSettingsSettingsSecurityRoute:
      appMainLayoutSettingsSettingsSecurityRoute,
    appMainLayoutSettingsSettingsUsersRoute:
      appMainLayoutSettingsSettingsUsersRoute,
    appMainLayoutSettingsSettingsWebhooksCallbacksRoute:
      appMainLayoutSettingsSettingsWebhooksCallbacksRoute,
  }

const appMainLayoutSettingsSettingsRouteWithChildren =
  appMainLayoutSettingsSettingsRoute._addFileChildren(
    appMainLayoutSettingsSettingsRouteChildren,
  )

interface appMainLayoutTransactionMonitoringTransactionMonitoringRouteChildren {
  appMainLayoutTransactionMonitoringTransactionMonitoringSplatRoute: typeof appMainLayoutTransactionMonitoringTransactionMonitoringSplatRoute
}

const appMainLayoutTransactionMonitoringTransactionMonitoringRouteChildren: appMainLayoutTransactionMonitoringTransactionMonitoringRouteChildren =
  {
    appMainLayoutTransactionMonitoringTransactionMonitoringSplatRoute:
      appMainLayoutTransactionMonitoringTransactionMonitoringSplatRoute,
  }

const appMainLayoutTransactionMonitoringTransactionMonitoringRouteWithChildren =
  appMainLayoutTransactionMonitoringTransactionMonitoringRoute._addFileChildren(
    appMainLayoutTransactionMonitoringTransactionMonitoringRouteChildren,
  )

interface appMainLayoutInStoreInStoreAgentsAgentIdRouteChildren {
  appMainLayoutInStoreInStoreAgentsAgentIdConfigRoute: typeof appMainLayoutInStoreInStoreAgentsAgentIdConfigRoute
}

const appMainLayoutInStoreInStoreAgentsAgentIdRouteChildren: appMainLayoutInStoreInStoreAgentsAgentIdRouteChildren =
  {
    appMainLayoutInStoreInStoreAgentsAgentIdConfigRoute:
      appMainLayoutInStoreInStoreAgentsAgentIdConfigRoute,
  }

const appMainLayoutInStoreInStoreAgentsAgentIdRouteWithChildren =
  appMainLayoutInStoreInStoreAgentsAgentIdRoute._addFileChildren(
    appMainLayoutInStoreInStoreAgentsAgentIdRouteChildren,
  )

interface appMainLayoutRouteChildren {
  appMainLayoutComplianceRoute: typeof appMainLayoutComplianceRouteWithChildren
  appMainLayoutSystemStatusRoute: typeof appMainLayoutSystemStatusRoute
  appMainLayoutBalancesBalancesRoute: typeof appMainLayoutBalancesBalancesRouteWithChildren
  appMainLayoutExchangeExchangeRoute: typeof appMainLayoutExchangeExchangeRouteWithChildren
  appMainLayoutLabsLabsRoute: typeof appMainLayoutLabsLabsRoute
  appMainLayoutPayByLinkPayByLinkRoute: typeof appMainLayoutPayByLinkPayByLinkRoute
  appMainLayoutPaymentsPaymentsRoute: typeof appMainLayoutPaymentsPaymentsRouteWithChildren
  appMainLayoutReportingReportingRoute: typeof appMainLayoutReportingReportingRoute
  appMainLayoutSettingsSettingsRoute: typeof appMainLayoutSettingsSettingsRouteWithChildren
  appMainLayoutTransactionMonitoringTransactionMonitoringRoute: typeof appMainLayoutTransactionMonitoringTransactionMonitoringRouteWithChildren
  appMainLayoutDashboardIndexRoute: typeof appMainLayoutDashboardIndexRoute
  appMainLayoutInStoreInStoreAgentsRoute: typeof appMainLayoutInStoreInStoreAgentsRoute
  appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute: typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute
  appMainLayoutPaymentsPaymentsPaymentIdRoute: typeof appMainLayoutPaymentsPaymentsPaymentIdRoute
  appMainLayoutInStoreInStoreAgentsAgentIdRoute: typeof appMainLayoutInStoreInStoreAgentsAgentIdRouteWithChildren
}

const appMainLayoutRouteChildren: appMainLayoutRouteChildren = {
  appMainLayoutComplianceRoute: appMainLayoutComplianceRouteWithChildren,
  appMainLayoutSystemStatusRoute: appMainLayoutSystemStatusRoute,
  appMainLayoutBalancesBalancesRoute:
    appMainLayoutBalancesBalancesRouteWithChildren,
  appMainLayoutExchangeExchangeRoute:
    appMainLayoutExchangeExchangeRouteWithChildren,
  appMainLayoutLabsLabsRoute: appMainLayoutLabsLabsRoute,
  appMainLayoutPayByLinkPayByLinkRoute: appMainLayoutPayByLinkPayByLinkRoute,
  appMainLayoutPaymentsPaymentsRoute:
    appMainLayoutPaymentsPaymentsRouteWithChildren,
  appMainLayoutReportingReportingRoute: appMainLayoutReportingReportingRoute,
  appMainLayoutSettingsSettingsRoute:
    appMainLayoutSettingsSettingsRouteWithChildren,
  appMainLayoutTransactionMonitoringTransactionMonitoringRoute:
    appMainLayoutTransactionMonitoringTransactionMonitoringRouteWithChildren,
  appMainLayoutDashboardIndexRoute: appMainLayoutDashboardIndexRoute,
  appMainLayoutInStoreInStoreAgentsRoute:
    appMainLayoutInStoreInStoreAgentsRoute,
  appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute:
    appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute,
  appMainLayoutPaymentsPaymentsPaymentIdRoute:
    appMainLayoutPaymentsPaymentsPaymentIdRoute,
  appMainLayoutInStoreInStoreAgentsAgentIdRoute:
    appMainLayoutInStoreInStoreAgentsAgentIdRouteWithChildren,
}

const appMainLayoutRouteWithChildren = appMainLayoutRoute._addFileChildren(
  appMainLayoutRouteChildren,
)

interface AuthAuthLayoutRouteChildren {
  AuthAuthLayoutForgotPasswordRoute: typeof AuthAuthLayoutForgotPasswordRoute
  AuthAuthLayoutSigninRoute: typeof AuthAuthLayoutSigninRoute
  AuthAuthLayoutSignupRoute: typeof AuthAuthLayoutSignupRoute
  AuthAuthLayoutFxAiApproveRoute: typeof AuthAuthLayoutFxAiApproveRoute
  AuthAuthLayoutResetPasswordTokenRoute: typeof AuthAuthLayoutResetPasswordTokenRoute
  AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute: typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute
  AuthAuthLayoutSignupSuccessRoute: typeof AuthAuthLayoutSignupSuccessRoute
  AuthAuthLayoutVerifyOtpOtpRequestIdRoute: typeof AuthAuthLayoutVerifyOtpOtpRequestIdRoute
}

const AuthAuthLayoutRouteChildren: AuthAuthLayoutRouteChildren = {
  AuthAuthLayoutForgotPasswordRoute: AuthAuthLayoutForgotPasswordRoute,
  AuthAuthLayoutSigninRoute: AuthAuthLayoutSigninRoute,
  AuthAuthLayoutSignupRoute: AuthAuthLayoutSignupRoute,
  AuthAuthLayoutFxAiApproveRoute: AuthAuthLayoutFxAiApproveRoute,
  AuthAuthLayoutResetPasswordTokenRoute: AuthAuthLayoutResetPasswordTokenRoute,
  AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute:
    AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute,
  AuthAuthLayoutSignupSuccessRoute: AuthAuthLayoutSignupSuccessRoute,
  AuthAuthLayoutVerifyOtpOtpRequestIdRoute:
    AuthAuthLayoutVerifyOtpOtpRequestIdRoute,
}

const AuthAuthLayoutRouteWithChildren = AuthAuthLayoutRoute._addFileChildren(
  AuthAuthLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AboutRoute: AboutRoute,
  AccountConfigurationErrorRoute: AccountConfigurationErrorRoute,
  ErrorRoute: ErrorRoute,
  appAdminLayoutRoute: appAdminLayoutRouteWithChildren,
  appMainLayoutRoute: appMainLayoutRouteWithChildren,
  AuthAuthLayoutRoute: AuthAuthLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
